define('lq/conditions/conditionEvaluator',[
    'underscore',
    'when',
    'lq/events/processEventActionsUrl',
    './operandEvaluator'
], function (_, when, processEventActionsUrl, OperandEvaluator) {

    var ConditionEvaluator = function (condition) {
        if (!condition.expression)
            throw new Error('The condition "' + condition.name + '" has an empty expression.');

        this.conditionId = condition.id;
        this.conditionName = condition.name;

        this.expression = this.prepareExpression(condition.expression);
        this.name = condition.name;

        this.operands = _.map(condition.operands, function (operand) {
            return new OperandEvaluator(operand);
        });
    };

    ConditionEvaluator.prototype.evaluate = function (piping, forceEvaluation, receivedDatasources, currentContextValue) {
        var d = when.defer();

        if (this.awaitingQueries) {
            return this.awaitingQueries;
        }

        if (this.previousExecutionData !== undefined && !forceEvaluation) {
            d.resolve(this.previousExecutionData);
        } else {
            var missingDatasources = this.findAllDataSources(receivedDatasources);

            var self = this;
            var evaluate = function (queryResults) {
                self.previousExecutionData = self.evaluateOperands(queryResults, piping, currentContextValue);
                delete self.awaitingQueries;
                d.resolve(self.previousExecutionData);
            };

            if (missingDatasources.length === 0) {
                evaluate(receivedDatasources);
            } else {
                this.awaitingQueries = d.promise;
                this.runQueries(missingDatasources, piping)
                    .done(
                        function (queryResults) {
                            receivedDatasources = receivedDatasources || {};

                            _.forEach(queryResults, function (queryResult) {
                                receivedDatasources[queryResult[0]] = queryResult[1];
                            });

                            evaluate(receivedDatasources);
                        },
                        $.noop); // let the global error handling code handle any errors
            }
        }

        return d.promise;
    };

    ConditionEvaluator.prototype.findAllDataSources = function (receivedDatasources) {
        var dataSources = [];

        _.each(this.operands, function (operand) {
            if (OperandEvaluator.isQueryOutput(operand.leftValue) && (!receivedDatasources || !receivedDatasources[operand.leftValue.query]))
                dataSources.push(operand.leftValue.query);
            if (OperandEvaluator.isQueryOutput(operand.rightValue) && (!receivedDatasources || !receivedDatasources[operand.rightValue.query]))
                dataSources.push(operand.rightValue.query);
        });

        return dataSources;
    };

    ConditionEvaluator.prototype.runQueries = function (missingDatasources, piping) {
        missingDatasources = _.uniq(missingDatasources);

        return piping.dispatcher
            .dispatch(processEventActionsUrl.get(piping, 'Conditions', this.name), {
                actionId: piping.actionId,
                globalParameters: piping.parameters.globals.getAll(),
                localParameters: piping.parameters.locals.getAll(),
                requests: _.map(missingDatasources, function (dataSource) {
                    return {
                        eventActionType: 'ExecuteQuery',
                        queryObjectName: dataSource,
                        queries: [
                            {
                                listeners: [],
                                params: {
                                    page: 0,
                                    pageSize: 1
                                }
                            }
                        ]
                    };
                })
            })
            .then(function (results) {
                return _.map(results.responses, function (response, i) {
                    var data = response.results[0].result.results.length > 0 ? response.results[0].result.results[0] : {};
                    return [missingDatasources[i], data];
                });
            });
    };

    ConditionEvaluator.prototype.evaluateOperands = function (queryResults, piping, currentContextValue) {
        var executableExpression = this.expression;
        var inputValues = {};

        _.each(this.operands, function (operand) {
            var value = operand.evaluate(queryResults, piping, currentContextValue);
            var nameToReplace = '(^| |\\()(' + operand.name + ')((?= |$|\\)))';
            inputValues[operand.name] = value;
            executableExpression = executableExpression.replace(new RegExp(nameToReplace, 'g'), '$1' + value + '$3');
        });

        return {
            condition: this,
            conditionResult: eval('(' + executableExpression + ')'),
            inputValues: inputValues,
        };
    };

    ConditionEvaluator.prototype.clearResult = function () {
        delete this.previousExecutionData;
    };

    ConditionEvaluator.prototype.prepareExpression = function (expression) {
        return expression
            .replace(/ and /gi, ' && ')
            .replace(/ or /gi, ' || ');
    };

    return ConditionEvaluator;
});
